import React, { useState, useEffect, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PhotoCamera from '@material-ui/icons/PhotoCamera';

import { Collapse, IconButton } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import CloseIcon from '@material-ui/icons/Close';
import LinearProgress from '@material-ui/core/LinearProgress';
import axios from 'axios';
import RefreshToken from '../../partials/RefreshToken';
import { AuthContext } from '../../../@jumbo/components/context/AuthContext';
import CircularProgress from '@material-ui/core/CircularProgress';

import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  alertRoot: {
    marginBottom: 10,
  },
  marginStyle: {
    margin: '7px 0',
  },

  titleDiv: {
    position: 'relative',
    margin: '15px 0',
  },
  iconDiv: {
    position: 'absolute',
    top: 0,
    right: 0,
  },
  alignCenter: {
    textAlign: 'center',
  },
  imgStyle: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  buttonMarginStyle: {
    margin: '16px 0 22px 0',
  },
  buttonStyle: {
    borderRadius: 25,
  },
}));

const MFSMicroserviceAddEdit = ({
  list,
  setList,
  editObj,
  setEditObj,
  editIndexNo,
  refresh,
  setRefresh,
  closeAddDialog,
  addDialog,
}) => {
  const classes = useStyles();
  const NoImage = '/images/icons/system.png';
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);
  const userId = glob_pay_admin_auth.user.sub;
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [preview, setPreview] = useState(NoImage);

  const [status, setStatus] = useState(false);

  const [loading, setLoading] = useState(false);

  const [addForm, setAddForm] = useState(true);
  const [editForm, setEditForm] = useState(false);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };
  const validation = () => {
    let isError = false;
    if (!name.trim()) {
      console.log('name');
      handleSnakbarOpen('Please enter name', 'error');
      document.getElementById('name').focus();
      return (isError = true);
    }
    if (!imageFile && addForm) {
      handleSnakbarOpen('Please upload image', 'error');
      document.getElementById('uploadBtn').focus();
      return (isError = true);
    }

    console.log('finish');
    return isError;
  };

  const clearStates = () => {
    setId('');
    setName('');
    setCode('');
    setImageFile(null);
    setPreview(NoImage);
    setStatus(false);
    setEditObj({});
  };
  const imageProcess = e => {
    if (e.target.files && e.target.files[0]) {
      let imageFile = e.target.files[0];

      const reader = new FileReader();
      reader.onload = x => {
        setImageFile(imageFile);
        setPreview(x.target.result);
      };
      reader.readAsDataURL(imageFile);
    } else {
      setImageFile(imageFile);
      setPreview(preview);
    }
  };
  const onSubmit = async e => {
    console.log('onSubmit');
    console.log('editIndexNo', editIndexNo);
    e.preventDefault();
    let err = validation();
    console.log('err', err);
    if (err) {
      return;
    } else {
      setLoading(true);
      const formdata = new FormData();
      formdata.append('name', name);
      formdata.append('code', code);
      formdata.append('status', status);
      formdata.append('logo', imageFile);
      let response;
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);
      try {
        if (addForm) {
          response = await axios({
            url: `/api/v1/private/mfs`,
            method: 'post',
            data: formdata,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setList([...list, response.data.data]);
          clearStates();
          console.log('addForm response', response);
        } else if (editForm) {
          response = await axios({
            url: `/api/v1/private/mfs/${id}`,
            method: 'put',
            data: formdata,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          console.log('editForm Submit', id, name, imageFile);
          console.log('editForm response', response);

          list[editIndexNo] = response.data.data;
          setRefresh(!refresh);
        }

        activeAddForm();

        handleSnakbarOpen(response.data.message, 'success');
        closeAddDialog();
      } catch (error) {
        console.log('error', error);
        console.log('errorresponse', error.response);

        setLoading(false);

        handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      }
      setLoading(false);
    }
  };

  const handleSwitch = () => {
    setStatus(!status);
  };

  useEffect(() => {
    if (editObj.id) {
      setAddForm(false);
      setEditForm(true);
      setId(editObj.id);
      setName(editObj.name);
      setCode(editObj.code);
      setPreview(editObj.logo);
      setStatus(editObj.status);
    }
  }, [editObj]);
  const activeAddForm = () => {
    clearStates();

    // setEditForm(false);
    // setAddForm(true);
  };

  useEffect(() => {
    if (addDialog === false) {
      activeAddForm();
    }
  }, [addDialog]);
  return (
    <React.Fragment>
      {/* <div className={classes.titleDiv}>
        {editForm && (
          <div className={classes.iconDiv}>
            <IconButton aria-label="close" color="inherit" size="small" onClick={activeAddForm}>
              <CloseIcon fontSize="inherit" />
            </IconButton>
          </div>
        )}
        <Typography variant="h4" className={`${classes.marginStyle} ${classes.alignCenter}`}>
          {editForm ? 'Update MFS' : 'Add MFS'}
        </Typography>
      </div> */}
      <div className={classes.titleDiv}>
        <div className={classes.iconDiv}>
          <IconButton
            style={{ background: 'gainsboro' }}
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => {
              closeAddDialog();
              activeAddForm();
            }}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </div>

        <Typography variant="h1" className={` ${classes.alignCenter}`}>
          {editForm ? 'Update MFS' : 'Add MFS'}
        </Typography>
      </div>

      <TextField
        id="name"
        label="Name"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={name}
        onChange={e => setName(e.target.value.toUpperCase())}
      />
      <TextField
        id="code"
        label="Code"
        variant="outlined"
        fullWidth
        size="small"
        className={`${classes.marginStyle} ${classes.inputStyle}`}
        value={code}
        onChange={e => setCode(e.target.value.toUpperCase())}
      />
      <div>
        <img src={preview} alt="" height="120px" className={classes.imgStyle} />
        <input accept="image/*" hidden id="contained-button-file" type="file" onChange={imageProcess} />

        <label htmlFor="contained-button-file">
          <Button
            id="uploadBtn"
            variant="outlined"
            color="primary"
            component="span"
            style={{ marginTop: '15px', borderRadius: '25px' }}
            fullWidth>
            <PhotoCamera /> Upload Image
          </Button>
        </label>
      </div>
      <div className={`${classes.marginStyle} ${classes.alignCenter}`}>
        <FormControlLabel
          control={<Switch checked={status} onChange={handleSwitch} name="status" color="primary" />}
          label="Status"
          labelPlacement="start"
        />
      </div>
      {/* <div className={classes.marginStyle}>
        {loading ? <LinearProgress /> : null}
        <Button variant="contained" color="primary" disabled={loading} fullWidth onClick={onSubmit}>
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div> */}
      <div className={classes.buttonMarginStyle}>
        {/* {loading ? <LinearProgress /> : null} */}

        <Button
          variant="contained"
          className={classes.buttonStyle}
          color="primary"
          disabled={loading}
          fullWidth
          onClick={onSubmit}>
          {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
          {editForm ? 'Update' : 'Save'}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default MFSMicroserviceAddEdit;
